import { useContext, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAnalyticsContext } from 'app/shared/utils';
import { getEventStatus } from 'app/shared/utils/calcEventState';
import { AlertContext } from 'app/shared/context';
import { useEventPageContext } from 'app/fan/context/EventPage';

import { useTrackProductViewed } from './useTrackProductViewed';

interface Props {
  checkoutDrawerOpenByDefault?: boolean;
}

export const useApplyFlowPage = ({
  checkoutDrawerOpenByDefault = false,
}: Props = {}) => {
  const { event, eventAttendee } = useEventPageContext();
  const [isCheckoutDrawerOpen, setIsCheckoutDrawerOpen] = useState(
    checkoutDrawerOpenByDefault
  );
  const { trackAnalyticsEvent } = useAnalyticsContext();
  const [numberOfTickets, setNumberOfTickets] = useState(2);
  const alertContext = useContext(AlertContext);
  const { formatMessage } = useIntl();

  useTrackProductViewed();

  const userHasTickets = eventAttendee?.currentState === 'confirmed';
  const eventStatus = getEventStatus(event);

  function openCheckoutDrawer() {
    trackAnalyticsEvent('Checkout Drawer Opened', {
      attendee_state: eventAttendee?.currentState,
      event_status: eventStatus,
      user_has_tickets: userHasTickets,
      event_id: event?.id,
    });
    setIsCheckoutDrawerOpen(true);
  }

  function onDrawerClose() {
    trackAnalyticsEvent('Checkout Drawer Closed', {
      attendee_state: eventAttendee?.currentState,
      event_status: eventStatus,
      user_has_tickets: userHasTickets,
      event_id: event?.id,
    });
  }

  function onError() {
    return alertContext.addAlert({
      message: formatMessage({ id: 'event.applyFlow.error' }),
      type: 'error',
      id: 'apply-flow-error-snackbar',
    });
  }

  return {
    isCheckoutDrawerOpen,
    setIsCheckoutDrawerOpen,
    openCheckoutDrawer,
    onDrawerClose,
    numberOfTickets,
    setNumberOfTickets,
    onError,
  };
};
